import queryString from 'query-string';
import { createSelector } from 'reselect';

import { GlobalAppState } from 'rdx/state';

export interface Query {
  selectedCategoryId?: string;
  search?: string;
  showSoldOutItems?: 'true' | 'false';
  mode?: 'view' | 'edit';
}

export const selectPathname = (state: GlobalAppState) => state.router.location.pathname;

export const selectQuery = (state: GlobalAppState): Query =>
  queryString.parse(state.router.location.search);

export const selectQueryParam = createSelector(
  selectQuery, // https://github.com/reduxjs/reselect/blob/v4.0.0/typescript_test/test.ts#L107
  (_state: GlobalAppState, param: keyof Query) => param,
  (query, param) => {
    return query[param];
  },
);
